import { render, staticRenderFns } from "./CrmSpaStaleUpdateBanner.vue?vue&type=template&id=4d1f8ed2&scoped=true&"
import script from "./CrmSpaStaleUpdateBanner.vue?vue&type=script&lang=ts&"
export * from "./CrmSpaStaleUpdateBanner.vue?vue&type=script&lang=ts&"
import style0 from "./CrmSpaStaleUpdateBanner.vue?vue&type=style&index=0&id=4d1f8ed2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1f8ed2",
  null
  
)

export default component.exports